<template>
  <div class="home-container">
    <!-- <van-nav-bar class="top-nav" title="砚雕防伪检测">
      <template #left>
        <van-icon name="cross" @click="goBack" />
      </template>
    </van-nav-bar> -->
    <div class="detailBox">
      <div class="title">河北省砚雕行业协会证书查询系统</div>
      <div class="iconBox">
        <!-- <van-image v-for="(item, index) in iconList" :key="index" width="82" height="100" :src="item.img" /> -->
        <van-image :src="require('@/assets/images/image.jpg')" width="100%" height="100%" />
      </div>
      <div class="productInfo">
        <div class="image">
          <van-image width="325" height="325" :src="detailObj.img" />
        </div>
        <div class="table">
          <van-cell-group>
            <van-cell title="检测编号" :value="detailObj.checkNo" />
            <van-cell title="鉴定结果" :value="detailObj.checkResult" />
            <van-cell title="总重量" :value="detailObj.weight" />
            <van-cell title="作品名称" :value="detailObj.name" />
            <van-cell title="作品规格" :value="detailObj.size" />
            <van-cell title="参考价值" :value="detailObj.price" />
            <van-cell title="设计师" :value="detailObj.designer" />
            <van-cell title="雕刻师" :value="detailObj.graver" />
            <van-cell title="鉴定师" :value="detailObj.appraiser" />
            <van-cell title="审核人" :value="detailObj.reviewer" />
          </van-cell-group>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      iconList: [
        {
          img: require('@/assets/images/1.jpg')
        },
        {
          img: require('@/assets/images/2.jpg')
        },
        {
          img: require('@/assets/images/3.jpg')
        },
        {
          img: require('@/assets/images/4.jpg')
        }
      ],
      detailObj: {}
    };
  },
  mounted() {
    this.queryProductDetail()
  },
  methods: {
    async queryProductDetail() {
      let res = await this.$api.detailProduct({id: this.$route.query.id});
      if (res.code === 200) {
        this.detailObj = res.data;
      } else {
        this.$toast(res.msg || '出错了');
      }
      console.log('res', res)
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="less" scoped>
.home-container {
  overflow: hidden;
  .top-nav {
    position: fixed;
    top: 0;
    width: 100%;
    background: #EBECEF;
  }
  .van-nav-bar__left {
    font-size: 18px;
  }
  .detailBox {
    margin: 10px 20px 0;
    .title {
      font-size: 18px;
      height: 35px;
      line-height: 35px;
      width: 100%;
      color: #ffffff;
      background-color: #409eff;
      text-align: center;
    }
    .iconBox {
      margin-top: 20px;
    }
    .productInfo {
      margin-top: 20px;
      .image {
        text-align: center;
      }
    }
  }
}
</style>
